import pricetag from '../icons/price-tag.svg'
export const plans = [
   {
    name: "Free",
    price: "$0.00 with ads",
    billing: "Monthly/Quarterly/Yearly",
    features: [
      { label: "1 Adult account", positive: true },
      { label: "Unlimited Canvas", positive: true },
      { label: "Unlimited Accounts", positive: true },
      { label: "Budget, Savings, Debts", positive: true },
      { label: "Display ads", positive: false },
    ],
    highlight: false,
    image:pricetag,
  },
  {
    name: "Free Trial",
    price: "$0.00",
    billing: "30 days free trial",
    features: [
      { label: "4 Adult accounts", positive: true },
      { label: "Unlimited Kids accounts", positive: true },
      { label: "Unlimited Canvas", positive: true },
      { label: "Shared Canvas", positive: true },
      { label: "Unlimited Accounts", positive: true },
    ],
    highlight: false,
    note: "No credit card required",
    image:pricetag,
  },
  {
    name: "Premium",
    price: "$4.49/mo",
    billing: "Monthly | $11.45 Quarterly | $37.72 Yearly",
    save: "$2.02+",
    features: [
      { label: "1 Adult account", positive: true },
      { label: "Unlimited Canvas", positive: true },
      { label: "Unlimited Accounts", positive: true },
      { label: "Investment Tracker", positive: true },
      { label: "No ads", positive: true },
    ],
    highlight: true,
    note: "Save more with yearly plan!",
    image:pricetag,
  },
  {
    name: "Premium Duo",
    price: "$6.74/mo",
    billing: "Monthly | $17.17 Quarterly | $56.57 Yearly",
    save: "$3.03+",
    features: [
      { label: "2 Adult accounts", positive: true },
      { label: "Unlimited Canvas", positive: true },
      { label: "Shared Canvas", positive: true },
      { label: "Investment Tracker", positive: true },
      { label: "No ads", positive: true },
    ],
    highlight: false,
    note: "Best for couples or partners",
    image:pricetag,
  },
  {
    name: "Family Plan",
    price: "$14.59/mo",
    billing: "Monthly | $37.21 Quarterly | $122.58 Yearly",
    save: "$6.57+",
    features: [
      { label: "4 Adult accounts", positive: true },
      { label: "Unlimited Kids accounts", positive: true },
      { label: "Unlimited Canvas", positive: true },
      { label: "Shared Canvas", positive: true },
      { label: "No ads", positive: true },
    ],
    highlight: false,
    note: "Best for families",
    image:pricetag,
  },
 
];
